// Localohost
// const API_BASE_URL = "http://localhost:8081";

// LightSail
// const API_BASE_URL = "http://13.206.12.226:8081";
const API_BASE_URL = "";

// Server Ip
// const API_BASE_URL = "http://15.222.76.59:8081";

// Utho URL
// const API_BASE_URL = "http://157.20.214.115:8081";





// Domain
// const API_BASE_URL = "https://ezioinfotech.com";
export default API_BASE_URL;    